export const DEVICES_STORAGE_FETCH_FILES = 'DEVICES_STORAGE_FETCH_FILES';
export const DEVICES_STORAGE_FETCH_FILES_REQUEST = 'DEVICES_STORAGE_FETCH_FILES_REQUEST';
export const DEVICES_STORAGE_FETCH_FILES_ERROR = 'DEVICES_STORAGE_FETCH_FILES_ERROR';